import { __awaiter, __generator } from "tslib";
import { getBridge } from './consumer';
/**
 * Displays a toast notification.
 *
 * Use the `config` parameter to:
 * * Control the toast's appearance.
 * * Set callback functions to run when the user sees or clicks on the toast.
 * * Create a clickable call-to-action that displays in the toast.
 *
 * Requests to display toasts may be queued and the toast may not be displayed immediately.
 *
 * The object returned by `shotToast` contains a function that can be used to remove the toast.
 *
 * @remarks Note: When the timeout parameter is set to none the toast is rendered into the page layout and pushes the rest of the page down. When timeout is set to normal, the toast appears on top of other content on the page.
 *
 * @param config - Toast configuration options.
 */
export var showToast = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            return [2 /*return*/, (_a = getBridge()).showToast.apply(_a, args)];
        });
    });
};
/**
 * Receives changes to the state of the page surrounding a dashboard component. You can use this data to dynamically update a dashboard component's content.
 *
 * The callback function passed to `observeState` is triggered when the dashboard component is initialized and every time the page is updated.
 *
 * The callback function should define the following parameters:
 * * `state`: For receiving state data.
 * * `envData`: For receiving general data about the user's current environment.
 *
 * The format of the `state` argument received by `observeState` depends on the page that hosts the dashboard component.
 *
 * @param observer - Callback function for receiving state data. Receives 2 parameters, `state` and `envData`.
 * @typeParam S - State's type, the first parameter sent to the callback.
 * @typeParam T - EnvData's type, the second parameter sent to the callback.
 */
export var observeState = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            return [2 /*return*/, (_a = getBridge()).observeState.apply(_a, args)];
        });
    });
};
/**
 * Navigates the user to another page in the dashboard.
 * If an invalid pageId value is passed to this function, a "Page Not Found" message is displayed in the dashboard.
 *
 * @param pageId - ID of the page to navigate to.
 */
export var navigate = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return (_a = getBridge()).navigate.apply(_a, args);
};
/**
 * Opens a modal.
 *
 * This function returns a promise that resolves when the modal is closed.
 * The object that the promise resolves to contains any data passed to the {@link CloseModal} function used to close the modal.
 *
 * @param componentId - ID of the component to show in the modal.
 * @param componentParams - Custom data to pass into the component.
 */
export var openModal = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            return [2 /*return*/, (_a = getBridge()).openModal.apply(_a, args)];
        });
    });
};
/**
 * Closes the currently open modal.
 *
 * @param closeData - Data to pass to the modal's opener. This data is returned by openModal once the modal is closed. Should not contain any functions as values.
 */
export var closeModal = function (closeData) {
    if (closeData === undefined) {
        return getBridge().closeModal();
    }
    var filteredArg = JSON.parse(JSON.stringify(closeData));
    return getBridge().closeModal(filteredArg);
};
export var getAccessToken = function () {
    return getBridge().getAccessToken();
};
export var authStrategy = function () { return ({
    getAuthHeaders: function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = {};
                    _b = {};
                    return [4 /*yield*/, getAccessToken()];
                case 1: return [2 /*return*/, (_a.headers = (_b.Authorization = _c.sent(),
                        _b),
                        _a)];
            }
        });
    }); },
}); };
//# sourceMappingURL=sdk.js.map